import { PropsWithChildren } from 'react';
import { cn } from '../../lib/helpers.ts';
import Skeleton from '../Skeleton.tsx';

interface BadgeProps extends PropsWithChildren {
    className?: string;
}

export default function Badge({ className, children }: BadgeProps) {
    return (
        <span
            className={cn(
                'my-1 w-auto items-start justify-start self-start rounded-lg bg-cloud-200 px-2 py-1 text-sm text-ink-800',
                className
            )}
        >
            {children}
        </span>
    );
}

export function BadgeSkeleton() {
    return <Skeleton className="my-1 block h-6 w-20 rounded-lg" />;
}
